import _extends from "@babel/runtime/helpers/extends";
import cn from 'classnames';
// @ts-ignore
import { calcFontColor } from '@platform-ui/utils/color';
// @ts-ignore
import getBackgroundMainColor from '@platform-ui/utils/getBackgroundMainColor';
import * as corners from '@platform-ui/flatCorners';
import styles from './Button.module.css';
const limitProgressiveFillValue = percent => Math.min(Math.max(percent, -100), 0);
function useButtonStyle(props, additionalStyles) {
  const {
    theme,
    isButtonLink,
    disabled,
    wide,
    wideTabletS,
    wideTabletL,
    wideDesktopS,
    wideDesktopM,
    wideDesktopL,
    inGroup,
    round,
    vertical,
    uppercase,
    unselectable,
    leftIcon,
    rightIcon,
    children,
    flatCorners,
    disableHorizontalPadding,
    disableVerticalPadding,
    progressiveFill,
    UNSAFE_className,
    UNSAFE_style
  } = props;
  const isIcon = (leftIcon || rightIcon) && !children;
  const themeType = typeof theme !== 'object' ? theme : 'custom';
  const customTheme = theme;
  const mergedClassName = className => additionalStyles != null && additionalStyles[className] ? cn(styles[className], additionalStyles[className]) : styles[className];
  const buttonClassName = cn({
    [mergedClassName('button')]: true,
    [mergedClassName(`button_theme_${themeType}`)]: !isButtonLink,
    [mergedClassName('button_theme_custom_hideOverlay')]: customTheme == null ? void 0 : customTheme.hideOverlay,
    [mergedClassName('button_disabled')]: disabled,
    [mergedClassName(`button_wide_${wide}`)]: wide,
    [mergedClassName(`button_wideTabletS_${wideTabletS}`)]: typeof wideTabletS !== 'undefined',
    [mergedClassName(`button_wideTabletL_${wideTabletL}`)]: typeof wideTabletL !== 'undefined',
    [mergedClassName(`button_wideDesktopS_${wideDesktopS}`)]: typeof wideDesktopS !== 'undefined',
    [mergedClassName(`button_wideDesktopM_${wideDesktopM}`)]: typeof wideDesktopM !== 'undefined',
    [mergedClassName(`button_wideDesktopL_${wideDesktopL}`)]: typeof wideDesktopL !== 'undefined',
    [mergedClassName('button_inGroup')]: inGroup,
    [mergedClassName('button_round')]: isIcon && round,
    [mergedClassName('button_isButtonLink')]: isButtonLink,
    [mergedClassName('button_inGroup_horizontal')]: inGroup && !vertical,
    [mergedClassName('button_inGroup_vertical')]: inGroup && vertical,
    [mergedClassName('button_uppercase')]: uppercase,
    [mergedClassName('button_unselectable')]: unselectable
  }, UNSAFE_className);
  let buttonStyle = {};
  if (customTheme) {
    buttonStyle = {
      color: customTheme.color || customTheme.background && calcFontColor(getBackgroundMainColor(customTheme.background)),
      // иначе (если ставить styles.backgroundOrigin = 'border-box') после смены обновления props и смены background
      // происходит сброс background-origin
      // вообще нужно для того, чтобы с градиентным фоном не появлялись артефакты на бордерах кнопки
      background: customTheme.background && `${customTheme.background} border-box`,
      '--tui-component--button--border-color': customTheme.borderColor || 'transparent'
    };
  }
  buttonStyle = _extends({}, buttonStyle, corners.style(flatCorners), UNSAFE_style);
  const buttonWrapperClassName = cn({
    [mergedClassName('buttonWrapper')]: true,
    [mergedClassName('buttonWrapper_disableHorizontalPadding')]: disableHorizontalPadding,
    [mergedClassName('buttonWrapper_disableVerticalPadding')]: disableVerticalPadding,
    [mergedClassName('buttonWrapper_isIcon')]: isIcon,
    [mergedClassName('buttonWrapper_leftIcon')]: !!leftIcon,
    [mergedClassName('buttonWrapper_rightIcon')]: !!rightIcon
  });
  const progressiveFillStyle = {};
  if (progressiveFill) {
    progressiveFillStyle.transform = `translateX(${limitProgressiveFillValue(-100 + progressiveFill)}%)`;
  }
  return {
    button: {
      className: buttonClassName,
      style: buttonStyle
    },
    buttonWrapper: {
      className: buttonWrapperClassName
    },
    progressiveFillContainer: {
      className: mergedClassName('progressiveFillContainer')
    },
    progressiveFill: {
      className: mergedClassName('progressiveFill'),
      style: progressiveFillStyle
    },
    icon: {
      className: mergedClassName('icon')
    },
    content: {
      className: mergedClassName('content')
    }
  };
}
export default useButtonStyle;